/* Defines the model for a Partner */

class Partner {
  declare id: string;

  declare name: string;

  declare shortName: string;

  declare squareLogo: string;

  declare rectangularLogo?: string;

  constructor({ id, name, shortName, squareLogo, rectangularLogo }: Partner) {
    this.id = id;
    this.name = name;
    this.shortName = shortName;
    this.squareLogo = squareLogo;
    this.rectangularLogo = rectangularLogo;
  }
}

export default Partner;
